import commonApi from './CommonApi.js';
import qs from "querystring";

export default {
	getAll: async (parameter) => {
		return await commonApi().get('/v1/contactGroupMembers/getAll', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getForDropdown: async (parameter) => {
		return await commonApi().get('/v1/contactGroupMembers/getForDropdown', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	create: async (viewModel) => {
		return await commonApi().post('/v1/contactGroupMembers', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	delete: async (parameters) => {
		return await commonApi().delete('/v1/contactGroupMembers', { params: parameters })
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	createGroupMembers: async (viewModel) => {
		return await commonApi().post('/v1/contactGroupMembers/createGroupMembers', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	saveUsersToGroup: async (viewModel) => {
		return await commonApi().post('/v1/contactGroupMembers/saveUsersToGroup', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	exportToExcelList: async (parameters) => {
		return await commonApi().get('/v1/contactGroupMembers/exportToExcelList',
			//{ params: parameters, responseType: 'blob' }
			{
				params: parameters,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				},
				responseType: 'blob'
			})
			.then((response) => {
				var fileName = 'Group-Members.xlsx';
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', fileName);
				document.body.appendChild(fileLink);
				fileLink.click();
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
}